__turbopack_context__.v({
  "badge": "Badge-module-scss-module__ERgEGq__badge",
  "badge_group": "Badge-module-scss-module__ERgEGq__badge_group",
  "badge_group_center": "Badge-module-scss-module__ERgEGq__badge_group_center",
  "badge_group_left": "Badge-module-scss-module__ERgEGq__badge_group_left",
  "badge_group_right": "Badge-module-scss-module__ERgEGq__badge_group_right",
  "badge_group_vertical": "Badge-module-scss-module__ERgEGq__badge_group_vertical",
  "badge_interior": "Badge-module-scss-module__ERgEGq__badge_interior",
  "badge_large": "Badge-module-scss-module__ERgEGq__badge_large",
  "badge_medium": "Badge-module-scss-module__ERgEGq__badge_medium",
  "badge_mo_large": "Badge-module-scss-module__ERgEGq__badge_mo_large",
  "badge_mo_medium": "Badge-module-scss-module__ERgEGq__badge_mo_medium",
  "badge_mo_small": "Badge-module-scss-module__ERgEGq__badge_mo_small",
  "badge_mo_xlarge": "Badge-module-scss-module__ERgEGq__badge_mo_xlarge",
  "badge_recommend": "Badge-module-scss-module__ERgEGq__badge_recommend",
  "badge_small": "Badge-module-scss-module__ERgEGq__badge_small",
  "badge_xlarge": "Badge-module-scss-module__ERgEGq__badge_xlarge",
});
